import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: [],
};

export const productTypesSlice = createSlice({
  name: 'productTypes',
  initialState,
  reducers: {
    setProductTypes: (state, action) => {
      state.value = action.payload
    },
  },
});

export const { setProductTypes } = productTypesSlice.actions;

export default productTypesSlice.reducer;